import { Box, Button, Typography } from '@mui/material'
import { Component } from 'react'

/**
 * Without this, any exception thrown while rendering (e.g. calling .join() on a value
 * the API now returns as a string) unmounts the whole React tree and leaves a blank
 * white page with nothing in the UI to say what happened — which is exactly how the
 * Roles-page crash presented. Catch it, keep the app shell usable, and show the real
 * error so the next one is diagnosable without a devtools session.
 */
class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // Keep the stack in the console for whoever is debugging.
    console.error('Render error:', error, info?.componentStack)
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <Box p={4}>
        <Typography fontSize={20} fontWeight="bold" mb={1}>
          Something went wrong on this screen.
        </Typography>
        <Typography mb={2} color="text.secondary">
          The page failed to render. The rest of the app still works — you can go back and
          try again. If this keeps happening, share the message below.
        </Typography>
        <Box
          mb={2}
          p={2}
          sx={{ background: 'rgb(244, 248, 249)', borderRadius: 1, fontFamily: 'monospace', fontSize: 13, overflowX: 'auto' }}
        >
          {String(error?.message || error)}
        </Box>
        <Button variant="contained" color="options" onClick={() => this.setState({ error: null })}>
          TRY AGAIN
        </Button>
      </Box>
    )
  }
}

export default ErrorBoundary
